import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { environment } from '@env/environment';
import { Globals } from '@theme/utils/globals';
import HC_drilldown from 'highcharts/modules/drilldown';
import { FilterService } from '@service/filter/filter.service';
import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {dashboardLotissementService} from '@service/dashboard-lotissement/dashboard-lotissement.service';
HC_drilldown(Highcharts);

@Component({
  selector: 'app-dash-lotissement',
  templateUrl: './dash-lotissement.component.html',
  styleUrls: ['./dash-lotissement.component.scss']
})
export class DashLotissementComponent implements OnInit {
  pieLotVe = 0
  pieLotRe = 0
  pieLotDi = 0

  //variable du graph
  public Highcharts = Highcharts;
  public barBasicChartOptions: any;
  public lineBasicChartOptions: any;

  widget : any
  listing : any
  echeanciers : []
  global = {country: Globals.country, device: Globals.device}
  dtOptions: any = {};
  etat: boolean = false
  userSession = Globals.user;
  isPrint: boolean = true;
  publicUrl = environment.publicUrl;
  total = [];
  totalI = [];
  totalP = [];
  ech = [];
  echI = [];
  echP = [];
  mois = [];
  type: string = 'TOUT';
  typeRow = [
    {label: 'Tout', value: 'TOUT'}
  ];
  event = {
    categorie: null,
    code: null,
    count: 10,
    create: null,
    dateD: null,
    dateF: null,
    etat: null,
    max: null,
    min: null,
    name: null,
    ordre: "ASC",
    type: "TOUT",
    uuid: null
  }

  nameTitle: string = "Projet de lotissement"
  name: boolean = true;
  nameType = 'ENTITY';
  nameClass= 'Subdivision';
  nameNamespace= 'Client';
  nameGroups= 'subdivision';

  public pieChartData: any;
  @ViewChild('doughnutChart', {static: false}) doughnutChart: ElementRef; // doughnut
  public pieChartTag: CanvasRenderingContext2D;

  constructor(
    public router: Router,
    private filterService: FilterService,
    private dashboardLotissementService: dashboardLotissementService
  ) {
    this.total = []
    this.totalP = []
    this.totalI = []
    this.ech = []
    this.echP = []
    this.echI = []
    this.mois = []
  }

  ngOnInit(): void {
    this.onFilter(this.event);
    this.dtOptions = Globals.dataTable;
  }
  onFilter($event) {
    this.type = $event.type
    this.filterService.dashboard($event, 'lotissement', null).subscribe(
      res => {
        this.getGraph();
        this.onSet(res);
    }, err => { })
  }

  onChangeLoad($event) {
    this.type = $event
    if($event === 'TOUT'){
    } else if($event === 'LOTISSEMENT'){
    } else if($event === 'ILOT'){
    }else if($event === 'LOT'){
    }
  }

  onPrinter($event){
    console.log($event)
    this.dashboardLotissementService.getPrinter($event,this.userSession?.agencyKey, this.userSession?.uuid)
  }

  onSet(res){
    console.log('data',res)
    this.etat = res ? true : false
    this.widget = res?.widget
    this.total = []
    this.totalP = []
    this.totalI = []
    this.ech = []
    this.echP = []
    this.echI = []
    this.mois = []
    this.listing = res?.listing
    this.echeanciers = res?.echeanciers
    res?.facture.forEach(el => {
      this.total.push(el?.total)
      this.totalP.push(el?.paye)
      this.totalI.push(el?.impaye)
      this.mois.push(el?.date)
    });
    res?.echeanciers.forEach(el => {
      this.ech.push(el?.prev)
      this.echP.push(el?.reg)
      this.echI.push(el?.reg > el?.prev ? 0 : el?.prev - el?.reg)
    });
    this.pieLotVe = res?.pieLot.ve
    this.pieLotRe = res?.pieLot.re
    this.pieLotDi = res?.pieLot.di
  }
  getGraph() {
    this.barBasicChartOptions = {
      chart: {
        type: 'column'
      },
      colors: ['blue', 'green', 'red'],
      title: {
        text: 'Statistique des paiements'
      },
      xAxis: {
        categories: (this.mois),
        crosshair: true
      },
      yAxis: {
        title: {
          text: this.global.device
        }
      },
      credits: {
        enabled: false
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>' ,
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{
        color: 'blue',
        name: 'Total prévisionnel',
        data: this.total

      }, {
        color: 'green',
        name: 'Total recouvré',
        data: this.totalP

      }, {
        color: 'red',
        name: 'Total des impayés',
        data: this.totalI
      },]
    };


    this.lineBasicChartOptions = {
      chart: {
        type: 'spline',
      },
      colors: ['#D9F0F3', 'green', 'red'],
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      yAxis: {
        title: {
          text: this.global.device
        }
      },
      xAxis: {
        categories: (this.mois),
        crosshair: true
      },
      credits: {
        enabled: false
      },
      series: [{
        name: 'Total prévisionnel',
        data: this.ech
      }, {
        name: 'Total recouvré',
        data: this.echP
      }, {
        name: 'Total des impayés',
        data: this.echI
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    };
  }
  getPie(){
    setTimeout(() => {
      /* pie cart */
      const pieTag = (((this.doughnutChart.nativeElement as HTMLCanvasElement).children));
      this.pieChartTag = ((pieTag['doughnut_chart']).lastChild).getContext('2d'); // doughnut_chart
      this.pieChartData = {
        labels: ['Occupé', 'Reservé', 'Disponible'],
        datasets: [{
          data: [this.pieLotVe, this.pieLotRe, this.pieLotDi,],
          backgroundColor: ['#ff5252','#ffa21d', '#0e9e4a'],
          hoverBackgroundColor: ['#ff5252','#ffa21d', '#0e9e4a']
        }]
      };
    });
  }
}
